<template>
  <div v-if="account && (mode === 'create' || account.id)">


    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <div class="box">
        <div
          class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2"
          v-if="mode !== 'create'"
         >
          <div class="flex flex-wrap items-center">
            <p class="text-3xl font-bold leading-none">{{ account.name }}</p>
            <div class="ml-2 leading-none border-l pl-2 border-white light:border-black">
              <p class="text-xs font-bold">Created at:</p>
              <p>
                {{ $moment(account.created_at).format(config.dateTimeFormats.display) }}
              </p>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-red text-xs text-black"
            @click.stop="deleteAccount(account.id)"
            v-if="!account.id_default"
          >
            <i class="fas fa-trash"></i>
            <span class="ml-1">Delete</span>
          </button>
        </div>

        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="name">Name</label>
            <ValidationProvider
              rules="required"
              name="name"
              v-slot="{ errors }"
            >
              <input
                name="name"
                type="text"
                id="name"
                class="form-control"
                v-model="account.name"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="description">Description</label>
            <input
              name="description"
              type="text"
              id="description"
              class="form-control"
              v-model="account.description"
            >
          </div>
        </div>


        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2" v-if="mode === 'create' || !account.is_default">
            <label class="block text-xs font-bold mb-2" for="account-type">Account type</label>
            <ValidationProvider
              name="account type"
              v-slot="{ errors }"
            >
              <div class="relative">
                <select
                  class="form-control pr-8"
                  id="account-type"
                  v-model="account.type"
                >
                  <option :value="type" v-for="(type, i) in accountTypes" :key="'account-types-' + i">{{ type }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2" v-if="mode === 'create'">
            <label class="block text-xs font-bold mb-2" for="balance">Balance</label>

            <ValidationProvider
              rules="currency"
              name="balance"
              v-slot="{ errors }"
            >
              <input
                name="balance"
                type="text"
                id="balance"
                class="form-control"
                v-model="account.balance"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="box p-2 pt-8 flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
          </button>
        </div>
      </div>
    </ValidationObserver>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    createAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mode: null,
      editID: null,
      accountID: this.$route.params.accountID,
      account: {},
      accountTypes: [],
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.setMode()
  },
  methods: {
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'financial-account' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.accountID) {
        this.editID = this.accountID
        this.mode = 'edit'
      } else if (this.$route.params.accountID) {
        this.editID = this.$route.params.accountID
      }

      this.getAccountTypes()
      if (this.mode === 'create') {
        this.account = this.emptyAccount()
      } else {
        this.get()
      }
    },
    emptyAccount() {
      return {
        name: '',
        description: '',
        type: 'bank',
        code: '',
        balance: '',
        details: {},
      }
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            this._reset()
          }
        })
    },
    _reset() {
      this.account = {}
      if (this.mode === 'create') {
        this.account = Object.assign({}, this.emptyAccount())
      } else {
        this.get()
      }
    },
    deleteAccount(accountID) {
      this.$swal.fire({
        title: 'Delete account',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('financial-accounts/' + accountID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.$router.push('/administration/financial-account/list')
              })
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // create / update
      if (this.mode === 'create') {
        axios.post('financial-accounts', this.account)
          .then((response) => {
            this.$emit('created', response.data)
            this._reset()

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Financial account created successfully!',
                type: 'success',
              })
                .then(() => this.$router.push('/administration/financial-account/list'))
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('financial-accounts/' + this.account.id, this.account)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Financial account updated successfully!',
              type: 'success',
            })
            this.$emit('updated', this.account)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    get() {
      axios.get('financial-accounts/' + this.accountID)
        .then((response) => {
          this.account = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Account not found',
            type: 'warning',
          })
        })
    },
    getAccountTypes() {
      axios.get('financial-accounts/types')
        .then((response) => {
          this.accountTypes = Object.assign([], response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Account not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
